var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadIc2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 7042",
    style: {
      fill: "none"
    },
    d: "M0 0h30v30H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 13622"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 13621"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18221",
    d: "M618.489 327.776H607a1.775 1.775 0 0 0-1.817 1.728v21.317a1.774 1.774 0 0 0 1.817 1.728h16.55a1.774 1.774 0 0 0 1.817-1.727v-16.213z",
    transform: "translate(-600.185 -324.775)",
    style: {
      strokeWidth: "1.8px",
      stroke: "#5a5a5a",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18222",
    d: "M624.935 334.846h-5.146a1.331 1.331 0 0 1-1.438-1.438v-5.3",
    transform: "translate(-599.77 -324.765)",
    style: {
      strokeWidth: "1.8px",
      stroke: "#5a5a5a",
      strokeMiterlimit: 10,
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 13608"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 13639"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 18220",
    d: "m6.795 0-3.35 3.263L0 .081",
    transform: "translate(12.001 16.368)",
    style: {
      strokeLinejoin: "round",
      strokeLinecap: "round",
      strokeWidth: "1.5px",
      stroke: "#5a5a5a",
      strokeMiterlimit: 10,
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 60",
    transform: "rotate(180 7.7 9.558)",
    style: {
      strokeLinecap: "round",
      strokeWidth: "1.5px",
      stroke: "#5a5a5a",
      strokeMiterlimit: 10,
      fill: "none"
    },
    d: "M0 0v6.97"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 13638"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 61",
    transform: "translate(11 22.744)",
    style: {
      strokeLinecap: "round",
      strokeWidth: "1.5px",
      stroke: "#5a5a5a",
      strokeMiterlimit: 10,
      fill: "none"
    },
    d: "M8.75 0H0"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 62",
    transform: "translate(19.75 20.887)",
    style: {
      strokeLinecap: "round",
      strokeWidth: "1.5px",
      stroke: "#5a5a5a",
      strokeMiterlimit: 10,
      fill: "none"
    },
    d: "M0 0v1.857"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC120 63",
    transform: "translate(11 20.887)",
    style: {
      strokeLinecap: "round",
      strokeWidth: "1.5px",
      stroke: "#5a5a5a",
      strokeMiterlimit: 10,
      fill: "none"
    },
    d: "M0 0v1.857"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIc2);
export default __webpack_public_path__ + "static/media/download_ic2.b664d3157015947be55539dd9f15e41d.svg";
export { ForwardRef as ReactComponent };